module.exports = __webpack_public_path__ + "img/breakfast.c6d182bd.png";